import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { Campagne, newCampagne } from '../models/campagnes';

interface State {
    campagne: Campagne,
}

const initialState: State = {
    campagne: { ...newCampagne }
};

export const editCampagneSlice = createSlice({
    name: 'editCampagne',
    initialState,
    reducers: {
        update(state, action: PayloadAction<Partial<Campagne>>) {
            state.campagne = { ...state.campagne, ...action.payload };
        },
    }
});
